import { Component, OnInit } from '@angular/core';
import {Gallery} from 'angular-gallery';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-individual-commercial',
  templateUrl: './individual-commercial.component.html',
  styleUrls: ['./individual-commercial.component.css']
})
export class IndividualCommercialComponent implements OnInit {

  constructor(public gallery: Gallery, public route: ActivatedRoute,private httpClient:HttpClient, private router: Router) {
    //(mapboxgl as any).accessToken = environment.mapbox.accessToken;
  }

  listing_id: string;
  listing_details: any=[];
  full_listing:any=[];
  images_array :any= [];
  property_attributes : {name:string, value:string}[];

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has("listing_id")) {
        this.listing_id = params.get("listing_id");
      }
      // console.log(this.listing_id);
    });
    const url = '/assets/commercial-data/commercial.json';
 
    this.httpClient.get(url).subscribe(data=>{
      // console.log(data);
      this.full_listing = data;
      
      this.listing_details=this.full_listing.filter((list:any)=>{
        return list.listingId ==this.listing_id;
      });
      
      

      // console.log(this.listing_details);
      for(var i = 0; i< this.listing_details[0].photos.length; i++) {
        var value = {
          path: this.listing_details[0].photos[i]
        }
        this.images_array.push(value);
        
      }
    //this.getPropertyAttributes()
    })

    // console.log(this.images_array);
    // var map = new mapboxgl.Map({
    //   container: 'map-property',
    //   style: 'mapbox://styles/mapbox/streets-v11',
    //   center: this.getLatLng(),
    //   zoom: 16
    // });
    

  }

  showGallery(index: number) {

      let prop = {
        images: this.images_array,
        index
      };
      this.gallery.load(prop);
      
  }

  closeGallery() {
      this.gallery.close();
  }

  getPrice(x) {
    var price = parseInt(x);
    var final_price = '$' + this.numberWithCommas(price);
    return final_price;
  }

  numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getPropertyAttributes() {
    var attribute = {
      name: "MLS#",
      value: this.listing_details[0].mlsId
    }
    this.property_attributes.push(attribute)
    // console.log(this.property_attributes)
    
  }

  contactAgent() {
    this.router.navigateByUrl("/contact");
  }
}
